import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faMinus } from '@fortawesome/pro-light-svg-icons'
import i18n from 'Lib/i18n'
import { MobileTextCss } from 'Features/pricing/tabs/PaidMarketing/PaidMarketing.styled'
import { isMobile } from 'react-device-detect'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

const faCheckIcon = (
  <FontAwesomeIcon icon={faCheck as IconProp} color={'var(--colors-primaryColor)'} width={'16px'} />
)
const faMinusIcon = <FontAwesomeIcon icon={faMinus as IconProp} />

export const BotMitigationTableData = {
  account: [
    {
      title: i18n.t('bot_mitigation.table_data.domains_protected', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.domains_protected', { ns: 'pricing' }),
      cells: [
        i18n.t('up_to', '', { number: 5, ns: 'pricing' }),
        i18n.t('up_to', '', { number: 30, ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.unlimited', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('bot_mitigation.table_data.yearly_visits', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.yearly_visits', {
        ns: 'pricing',
      }),
      cells: [
        i18n.t('up_to', '', { number: '1.5M', ns: 'pricing' }),
        i18n.t('up_to', '', { number: '1.5M', ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.unlimited', { ns: 'pricing' }),
      ],
    },
  ],
  protection: [
    {
      title: i18n.t('bot_mitigation.table_data.monitoring_mode', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.monitoring_mode', {
        ns: 'pricing',
      }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.bot_detection', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.bot_detection', {
        ns: 'pricing',
      }),
      cells: [
        i18n.t('bot_mitigation.table_data.all_websites', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.all_websites', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.all_websites', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('bot_mitigation.table_data.bot_blocking', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.bot_blocking', {
        ns: 'pricing',
      }),
      cells: [
        i18n.t('bot_mitigation.table_data.wordpress_only', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.wordpress_only', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.all', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('bot_mitigation.table_data.interception_type', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.interception_type', {
        ns: 'pricing',
      }),
      cells: [
        i18n.t('bot_mitigation.table_data.pre_defined', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.pre_defined', { ns: 'pricing' }),
        i18n.t('bot_mitigation.table_data.open_for_user_implementation', { ns: 'pricing' }),
      ],
    },
    {
      title: i18n.t('bot_mitigation.table_data.user_defined_allow_list', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.user_defined_allow_list', {
        ns: 'pricing',
      }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.customizable_detection_rules', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.customizable_detection_rules', {
        ns: 'pricing',
      }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.allow_blocking_on_specific_landing_pages', {
        ns: 'pricing',
      }),
      tooltip: i18n.t('bot_mitigation.tooltips.allow_blocking_specific', {
        ns: 'pricing',
      }),
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.integration_for_interception', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.integration_for_interception', {
        ns: 'pricing',
      }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.user_data_validation', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.user_data_validation', {
        ns: 'pricing',
      }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
  ],
  reporting: [
    {
      title: i18n.t('bot_mitigation.table_data.per_visit_analytics', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.per_visit_analytics', {
        ns: 'pricing',
      }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.aggregated_insights', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.aggregated_insights', {
        ns: 'pricing',
      }),
      cells: [faCheckIcon, faCheckIcon, faCheckIcon],
    },
    {
      title: i18n.t('bot_mitigation.table_data.scheduled_reports', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.scheduled_reports', {
        ns: 'pricing',
      }),
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
  ],
  service: [
    {
      title: i18n.t('bot_mitigation.table_data.support', { ns: 'pricing' }),
      tooltip: i18n.t('bot_mitigation.tooltips.support', {
        ns: 'pricing',
      }),
      cells: [
        i18n.t('bot_mitigation.twenty_four_seven', {
          ns: 'pricing',
        }),
        i18n.t('bot_mitigation.twenty_four_seven', {
          ns: 'pricing',
        }),
        i18n.t('bot_mitigation.customer_success_manager', {
          ns: 'pricing',
        }),
      ],
    },
    {
      title: i18n.t('bot_mitigation.table_data.technical_implementation_manager', {
        ns: 'pricing',
      }),
      tooltip: i18n.t('bot_mitigation.tooltips.technical_onboarding_manager', {
        ns: 'pricing',
      }),
      featureNameCss: isMobile ? MobileTextCss : {},
      cells: [faMinusIcon, faMinusIcon, faCheckIcon],
    },
  ],
}
